export const Times = {
  YESTERDAY: 'Včera',
  NOW: 'Právě teď',
  TODAY: 'Dnes',
  TOMORROW: 'Zítra'
}
